// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_JUbka","foot_link":"index_foot_link_0thWQ","list":"index_list_zOEMp","link":"index_link_SY3Kx","copyright":"index_copyright_mYWoM"};